export default function (channels, channel_title, type) {
  const channel = channels.find(channel => channel.title === channel_title);
  return channel[`min_${type}_rate`]
}
